import type { TextProps } from '@consta/uikit/Text'
import { Text } from '@consta/uikit/Text'
import type { TooltipProps } from '@consta/uikit/withTooltip'
import { withTooltip } from '@consta/uikit/withTooltip'
import type { PropsWithChildren } from 'react'
import { forwardRef } from 'react'

const TextWithTooltip = withTooltip({
  appearTimeout: 500,
  direction: 'downCenter',
  possibleDirections: ['downCenter'],
})(Text)

type TextWithDisablingTooltipProps = TextProps & {
  disabled?: boolean
  tooltipProps: TooltipProps
  className?: string
}

export const TextWithDisablingTooltip = forwardRef<
  HTMLDivElement,
  PropsWithChildren<TextWithDisablingTooltipProps>
>(function TextWithDisablingTooltip(
  { children, disabled, tooltipProps, className, ...props },
  ref,
) {
  if (disabled) {
    return (
      <Text ref={ref} {...props} className={className}>
        {children}
      </Text>
    )
  }
  return (
    <TextWithTooltip ref={ref} {...props} className={className} tooltipProps={tooltipProps}>
      {children}
    </TextWithTooltip>
  )
})
